module.exports = __webpack_public_path__ + "static/media/24hf-long.3c3aa553.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/DGR/Home/24hf-long.png
// module id = 702
// module chunks = 0